import React from "react";
import  ReactDOM from "react-dom";

import App from "./components/App"


const reactDocumentRoot = document.querySelector("#root")

ReactDOM.render(
  
    <App />
  
    , reactDocumentRoot)